import { render, staticRenderFns } from "./DeleteConfim.vue?vue&type=template&id=592f9bb1&"
import script from "./DeleteConfim.vue?vue&type=script&lang=js&"
export * from "./DeleteConfim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports